const barGraphics = {
  lbldaterange: "Choose a date range",
  zones: {
    zone: "Zone",
    smooth: "Smooth",
    warning: "Warning",
    alarm: "Alarm"
  },
  lblinspections: "Inspections",
  buttons: {
    cancel: "Cancel"
  }
};
export default barGraphics;
